import { useFieldArray, useForm, Controller } from "react-hook-form";
import Select from "../../Components/Common Components/Select/Select";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import authService from "../../Services/authService";
import DatePicker from "../../Components/Common Components/DatePicker/DatePicker";
import {
  message,
  Modal,
  Popconfirm,
  Popover,
  Space,
  Spin,
  Table,
  Tooltip,
} from "antd";
import Empty from "../../Components/Common Components/Empty/Empty";
import { isEmpty } from "lodash";
import Header from "../Auth/Header";
import { SearchOutlined } from "@ant-design/icons";
import Button from "../../Components/Common Components/Button/Button";
import Input from "../../Components/Common Components/Input/Input";
import dayjs from "dayjs";
import Checkbox from "../../Components/Common Components/Checbox/Checkbox";

const TaxGroup = () => {
  const {
    watch,
    control,
    setValue,
    setError,
    getValues,
    handleSubmit,
    formState: { errors },
    clearErrors,
  } = useForm({
    defaultValues: { items: [], stock: true, active: true },
    shouldUnregister: false,
  });
  const { fields, replace } = useFieldArray({
    control,
    name: "items",
  });

  const [page, setPage] = useState("1");
  const pageSize = 25;
  const [totalCount, setTotalCount] = useState(0);
  const [persistedValues, setPersistedValues] = useState({});
  const [catergory, setCatergory] = useState();
  const [departmentList, setDepartmentList] = useState();
  const [manufacturerOptions, setManufacturerOptions] = useState();
  const [distributorOptions, setDistributorOptions] = useState();
  const [taxGroupOptions, setTaxGroupOptions] = useState();
  const [hsnCodeOptions, setHsnCodeOptions] = useState();
  const [messageApi, messageContextHolder] = message.useMessage();
  const [responseData, setResponseData] = useState();
  const [loading, setLoading] = useState(false);
  const [popConfirmRow, setPopConfirmRow] = useState(null);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);
  const [selectedValue, setSelectedValue] = useState(null);
  const [itemNameList, setItemNameList] = useState([]);
  const [applyType, setApplyType] = useState(null);
  const storedPermissions = localStorage.getItem("userPermissions");
  const permissions = storedPermissions ? JSON.parse(storedPermissions) : [];
  const draftPermission = permissions.find((p) => p.permission === "6");
  const approverPermission = permissions.find((p) => p.permission === "8");
  const canDraft = draftPermission ? Number(draftPermission.cnt) > 0 : false;
  const canApprove = approverPermission
    ? Number(approverPermission.cnt) > 0
    : false;
  const today = new Date().toISOString().split("T")[0];

  const rowSelection = useMemo(
    () => ({
      selectedRowKeys,
      onChange: (newSelectedKeys, newSelectedRows) => {
        setSelectedRowKeys(newSelectedKeys);
        setSelectedRows(newSelectedRows);
      },
    }),
    [selectedRowKeys],
  );
  const autoSelectRow = (record) => {
    const key = record.itemId;
    setSelectedRowKeys((prevKeys) => {
      if (prevKeys.includes(key)) return prevKeys;
      return [...prevKeys, key];
    });
    setSelectedRows((prevRows) => {
      const exists = prevRows.find((r) => r.itemId === key);
      if (exists) return prevRows;
      return [...prevRows, record];
    });
  };
  const showStock = watch("stock");
  const activeItems = watch("active");
  console.log("activeItems", activeItems, showStock);

  const formatedData = (
    searchText,
    includeManufacturer = false,
    includedistributor = false,
  ) => {
    return [
      {
        name: "",
        tables: {
          parameter: [
            {
              searchtext: searchText,
              ...(includeManufacturer && { includemanufacturer: "1" }),
              ...(includedistributor && { includesupplier: "1" }),
              ...(includedistributor && { includedistributor: "1" }),
            },
          ],
        },
      },
    ];
  };
  const jsonData = (
    currentDepartmentId,
    currentManufacturerId,
    currentDistributorId,
    currentCategoryId,
    pageno,
    categoryItemId,
    hsnId,
    taxGroupId,
    itemCodeId,
    itemCategoryId,
    itemHsnsnId,
    itemname,
  ) => {
    console.log("currentDepartmentId", activeItems, showStock);
    return [
      {
        name: "",
        tables: {
          parameter: [
            {
              activestatus: activeItems ? "1" : "0",
              departmentid: currentDepartmentId,
              distributerid: currentDistributorId,
              hsn: hsnId || itemHsnsnId,
              itemcontentid:
                currentCategoryId || categoryItemId || itemCategoryId || "",
              itemgroupid: "",
              is_drafted: canApprove ? "1" : canDraft ? "0" : "0",
              itemid: itemname ? itemname : "",
              itemcode: itemCodeId ? itemCodeId : "",
              manufactureid: currentManufacturerId,
              parentitemid: "",
              partyid: "",
              status: "4",
              taxgroupid: taxGroupId,
              pageno: pageno,
              show_stockonly: showStock ? "1" : "0",
              vdotfrom: "2024-04-01",
              vdotto: today,
            },
          ],
        },
      },
    ];
  };
  const getItemcodeList = async (value, methodName) => {
    const formattedData = formatedData(value);
    const response = await authService.getOptionslist(
      formattedData,
      methodName,
    );
    const responseData = response?.data?.tables?.list;
    const result = Object.values(responseData);
    if (!responseData) {
      setItemNameList([]);
      return;
    }
    if (result.length === 1 && result[0].no_data === "1") {
      setItemNameList([]);
    } else {
      setItemNameList(result);
    }
    return result;
  };
  const getCatergoryList = async (value, methodName) => {
    const formattedData = formatedData(value);
    const response = await authService.getOptionslist(
      formattedData,
      methodName,
    );
    const responseData = response?.data?.tables?.list;
    const result = Object.values(responseData);

    if (!responseData) {
      setCatergory([]);
      return;
    }
    if (result.length === 1 && result[0].no_data === "1") {
      setCatergory([]);
    } else {
      setCatergory(result);
    }
    return result;
  };
  const getTaxGroupList = async (value, methodName) => {
    const formattedData = formatedData(value);
    const response = await authService.getOptionslist(
      formattedData,
      methodName,
    );
    const responseData = response?.data?.tables?.list;
    const result = Object.values(responseData);

    if (result.length === 1 && result[0].no_data === "1") {
      setTaxGroupOptions([]);
    } else {
      setTaxGroupOptions(result);
      return result;
    }
  };
  const getHsnCodeList = async (value, methodName) => {
    const formattedData = formatedData(value);
    const response = await authService.getOptionslist(
      formattedData,
      methodName,
    );
    const responseData = response?.data?.tables?.list;
    const result = Object.values(responseData);
    setHsnCodeOptions(result);
    return result;
  };
  const getManufacturerList = async (
    value,
    methodName,
    includeManufacturer,
    includedistributor,
  ) => {
    const formattedData = formatedData(
      value,
      includeManufacturer,
      includedistributor,
    );
    const response = await authService.getOptionslist(
      formattedData,
      methodName,
    );
    const responseData = response?.data?.tables?.list;
    const result = Object.values(responseData);

    if (!responseData) {
      setManufacturerOptions([]);
      setDistributorOptions([]);
      return;
    }
    if (result.length === 1 && result[0].no_data === "1") {
      setManufacturerOptions([]);
      setDistributorOptions([]);
    } else {
      if (includeManufacturer) {
        setManufacturerOptions(result);
      } else {
        setDistributorOptions(result);
      }
    }
  };
  const getdepartmentlist = async (value, methodName) => {
    const formattedData = formatedData(value);
    const response = await authService.getOptionslist(
      formattedData,
      methodName,
    );
    const responseData = response?.data?.tables?.list;
    const result = Object.values(responseData);

    if (!responseData) {
      setDepartmentList([]);
      return;
    }
    if (result.length === 1 && result[0].no_data === "1") {
      setDepartmentList([]);
    } else {
      setDepartmentList(result);
    }
  };

  const departmentId = watch("department");
  const manufacturerId = watch("manufacturer")?.value;
  const distributorId = watch("distributor")?.value;
  const catergoryId = watch("category")?.value;
  const itemnameId = watch("itemname")?.value;
  console.log("departmentId", hsnCodeOptions);

  const tableList = async (filters, pageno = page) => {
    setLoading(true);
    try {
      const currentValues = getValues();
      const currentDepartmentId =
        currentValues.department?.map((item) => item.value).join(",") || "";
      const currentManufacturerId = currentValues.manufacturer?.value;
      const currentDistributorId = currentValues.distributor?.value;
      const currentCategoryId = currentValues.category?.value;
      const currentFilters = currentValues.filters;
      const categoryItemId = currentValues?.filters?.category?.label?.value;
      const hsnId = currentValues?.filters?.hsn?.label?.value;
      const taxGroupId = currentValues?.filters?.taxgroup?.value;
      const itemCodeId = currentValues?.filters?.itemcode?.label;
      const itemCategoryId = currentValues?.filters?.category?.value;
      const itemHsnsnId = currentValues?.filters?.hsn?.value;
      const itemname = currentValues?.itemname?.value;
      const formattedData = jsonData(
        currentDepartmentId,
        currentManufacturerId,
        currentDistributorId,
        currentCategoryId,
        pageno,
        categoryItemId,
        hsnId,
        taxGroupId,
        itemCodeId,
        itemCategoryId,
        itemHsnsnId,
        itemname,
      );
      const response = await authService.getTableList(
        formattedData,
        "report.customreport.itemReport",
      );
      const responseResult = Object.values(response?.data?.tables?.reportdata1);
      setResponseData(responseResult);
      setTotalCount(response?.data?.tables?.pagecount[0]?.pagecount || 0);
      if (responseResult.length === 1 && responseResult[0].no_data === "1") {
        replace([]);
      } else {
        const mappedItems = responseResult.map((row) => {
          return {
            itemId: row.itemid,
            itemcode: row.itemcode,
            itemname: row.itemname,
            category: row.category,
            hsn: row.hsn,
            taxgroup: row.taxgroup,
            taxgroupid: row.taxgroupid,
            tax_datefrom: row.tax_datefrom,
            tax_dateto: row.tax_dateto,
            current_tax_rowno: row.current_tax_rowno,
            drafted_tax_rowno: row.drafted_tax_rowno,
            drafted_taxgroupid: row.drafted_taxgroupid,
            drafted_taxgroup: row.drafted_taxgroup,
            drafted_hsn: row.drafted_hsn,
            drafted_hsnid: row.drafted_hsnid,
            drafted_datefrom: row.drafted_datefrom,
            drafted_category: row.drafted_category,
            drafted_categoryid: row.drafted_categoryid,
            hsn_remark: row.hsn_remark,
            taxGroup: null,
            hsnCode: null,
            startDate: "",
          };
        });

        replace(mappedItems);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (canApprove && fields?.length) {
      fields.forEach((item, index) => {
        if (item?.drafted_taxgroupid && item?.drafted_taxgroup) {
          setValue(
            `items.${index}.${"taxGroup"}`,
            { value: item?.drafted_taxgroupid, label: item?.drafted_taxgroup },
            { shouldDirty: true },
          );
          fields[index].isModified = true;
        }
        if (item?.drafted_hsn && item?.drafted_hsnid) {
          setValue(
            `items.${index}.${"hsnCode"}`,
            { value: item?.drafted_hsnid, label: item?.drafted_hsn },
            { shouldDirty: true },
          );
          fields[index].isModified = true;
        }
        if (item?.drafted_datefrom) {
          const formattedDate = new Date(item?.drafted_datefrom)
            .toISOString()
            .split("T")[0];
          setValue(`items.${index}.startDate`, formattedDate, {
            shouldDirty: true,
          });
          fields[index].isModified = true;
        }
        if (item?.drafted_category && item?.drafted_categoryid) {
          setValue(
            `items.${index}.${"newcategory"}`,
            { value: item?.drafted_categoryid, label: item?.drafted_category },
            { shouldDirty: true },
          );
          fields[index].isModified = true;
        }
      });
    }
  }, [canApprove, fields, setValue]);

  //may need this logic for feature use

  // useEffect(() => {
  //   if (!fields || !persistedValues) return;

  //   fields.forEach((_, i) => {
  //     Object.entries(persistedValues).forEach(([key, value]) => {
  //       setValue(`items.${i}.${key}`, value, { shouldDirty: true });
  //     });
  //   });
  // }, [fields, persistedValues]);
  useEffect(() => {
    if (!fields || !persistedValues || !selectedRowKeys.length) return;

    fields.forEach((item, i) => {
      if (selectedRowKeys.includes(item.itemId)) {
        Object.entries(persistedValues).forEach(([key, value]) => {
          setValue(`items.${i}.${key}`, value, { shouldDirty: true });
        });
      }
    });
  }, [fields, persistedValues, selectedRowKeys]);

  useEffect(() => {
    if (departmentId || manufacturerId || distributorId || catergoryId || itemnameId) {
      tableList();
    }
  }, [
    departmentId,
    manufacturerId,
    distributorId,
    catergoryId,
    itemnameId,
    page,
    activeItems,
    showStock,
  ]);

  const getPreviousDate = (dateStr) => {
    if (!dateStr) return "";
    const d = new Date(dateStr);
    d.setDate(d.getDate() - 1);
    return d.toISOString().split("T")[0];
  };

  // const onSubmit = async (data) => {

  //   const selectedItemIds = new Set(selectedRowKeys);
  //   const modifiedRows = data.items.filter(
  //     (row, idx) =>
  //       (fields[idx]?.isModified || selectedItemIds.has(row.itemId)) &&
  //       row.taxGroup?.value &&
  //       row.hsnCode?.value &&
  //       row.startDate,
  //   );
  //   console.log("modifiedRows", modifiedRows);

  //   if (modifiedRows.length === 0) {
  //     message.info("No changes to save");
  //     messageApi.open({
  //       type: "success",
  //       content: "No changes to save",
  //     });
  //     return;
  //   }

  //   const itemTax = modifiedRows.flatMap((row) => {
  //     const newCurrentTaxRowNo = Number(row.current_tax_rowno) + 1;
  //     const draftedTaxRowno = Number(row.drafted_tax_rowno) + 1;
  //     const prevDate = getPreviousDate(row.startDate);
  //     return [
  //       {
  //         itemid: row.itemId,
  //         datefrom: row.tax_datefrom,
  //         dateto: prevDate,
  //         taxgroupid: row.taxgroupid,
  //         rowno: row.current_tax_rowno,
  //         categoryid: row?.category?.value ? row?.category?.value : "",
  //         // rowno: canApprove ? row.drafted_tax_rowno : row.current_tax_rowno,
  //       },

  //       {
  //         itemid: row.itemId,
  //         datefrom: row.startDate,
  //         dateto: row.tax_dateto,
  //         taxgroupid: row.taxGroup?.value,
  //         hsnid: row.hsnCode?.value,
  //         rowno: String(newCurrentTaxRowNo),
  //         categoryid: row?.category?.value ? row?.category?.value : "",
  //         // rowno: canApprove
  //         //   ? String(draftedTaxRowno)
  //         //   : String(newCurrentTaxRowNo),
  //       },
  //     ];
  //   });

  //   const payload = [
  //     {
  //       name: "",
  //       tables: {
  //         parameter: [
  //           {
  //             statusfrom: canApprove ? "1" : "0",
  //             statusto: canApprove ? "4" : "1",
  //           },
  //         ],
  //         item_tax: itemTax,
  //       },
  //     },
  //   ];

  //   console.log("payload", payload);
  //   try {
  //     const response = await authService.saveTaxGroups(
  //       payload,
  //       "inv.item.saveItemTax",
  //     );
  //     const result = response?.data?.tables?.result[0];
  //     console.log("authData", result);
  //     if (result?.type === "-1") {
  //       await messageApi.open({
  //         type: "error",
  //         content: "something went wrong changes are not saved",
  //       });
  //     } else if (result?.type === "1") {
  //       await messageApi.open({
  //         type: "success",
  //         content: "Successfully Changes are Saved",
  //       });
  //     }
  //   } catch (error) {
  //     console.error("API request failed:", error);
  //   } finally {
  //   }
  // };
  const onSubmit = async (data) => {
    const selectedItemIds = new Set(selectedRowKeys);
    const items = data.items || [];

    let hasError = false;
    const validRows = [];

    items.forEach((row, idx) => {
      const isModified = fields[idx]?.isModified;
      const isSelected = selectedItemIds.has(row.itemId);
      if (isModified || isSelected) {
        if (!row.taxGroup?.value) {
          setError(`items.${idx}.taxGroup`, {
            type: "manual",
            message: "Tax Group is required",
          });
          hasError = true;
        }

        if (!row.hsnCode?.value) {
          setError(`items.${idx}.hsnCode`, {
            type: "manual",
            message: "HSN Code is required",
          });
          hasError = true;
        }

        if (!row.startDate) {
          setError(`items.${idx}.startDate`, {
            type: "manual",
            message: "Start Date is required",
          });
          hasError = true;
        }
        if (!row.newcategory) {
          setError(`items.${idx}.newcategory`, {
            type: "manual",
            message: "New Category is required",
          });
          hasError = true;
        }
        if (
          row.taxGroup?.value &&
          row.hsnCode?.value &&
          row.startDate &&
          row.newcategory?.value
        ) {
          validRows.push(row);
        }
      }
    });

    if (hasError) {
      messageApi.open({
        type: "error",
        content: "Please fill required fields in highlighted rows",
      });
      return;
    }

    if (validRows.length === 0) {
      messageApi.open({
        type: "info",
        content: "No changes to save",
      });
      return;
    }

    const itemTax = validRows.flatMap((row) => {
      const newCurrentTaxRowNo = Number(row.current_tax_rowno) + 1;
      const prevDate = getPreviousDate(row.startDate);
      return [
        {
          itemid: row.itemId,
          datefrom: row.tax_datefrom,
          dateto: prevDate,
          taxgroupid: row.taxgroupid,
          rowno: row.current_tax_rowno,
        },
        {
          itemid: row.itemId,
          datefrom: row.startDate,
          dateto: row.tax_dateto,
          taxgroupid: row.taxGroup?.value,
          hsnid: row.hsnCode?.value,
          rowno: String(newCurrentTaxRowNo),
          categoryid: row?.newcategory?.value || "",
        },
      ];
    });

    const payload = [
      {
        name: "",
        tables: {
          parameter: [
            {
              statusfrom: canApprove ? "1" : "0",
              statusto: canApprove ? "4" : "1",
            },
          ],
          item_tax: itemTax,
        },
      },
    ];

    try {
      const response = await authService.saveTaxGroups(
        payload,
        "inv.item.saveItemTax",
      );

      const result = response?.data?.tables?.result[0];

      if (result?.type === "-1") {
        await messageApi.open({
          type: "error",
          content: "Something went wrong. Changes are not saved",
        });
      } else if (result?.type === "1") {
        await messageApi.open({
          type: "success",
          content: "Successfully changes are saved",
        });
      }
    } catch (error) {
      console.error("API request failed:", error);
    }
  };

  const getColumnSearchProps = useCallback(
    (dataIndex, fetchOptions, setValue, control) => {
      const stableFetchOptions = async (value) => {
        try {
          const results = await fetchOptions(value);
          return Array.isArray(results) ? results : [];
        } catch (error) {
          console.error("Search error:", error);
          return [];
        }
      };

      return {
        filterDropdown: (props) => (
          <ColumnSearchDropdown
            {...props}
            dataIndex={dataIndex}
            fetchOptions={stableFetchOptions}
            setFilterValue={(field, valueObj) => {
              setValue(field, valueObj, { shouldDirty: true });
            }}
            control={control}
          />
        ),

        filterIcon: (filtered) => (
          <SearchOutlined style={{ color: filtered ? "#1890ff" : undefined }} />
        ),
      };
    },
    [],
  );
  const ColumnSearchDropdown = ({
    dataIndex,
    setFilterValue,
    control,
    confirm,
    clearFilters,
    fetchOptions,
  }) => {
    const [searchText, setSearchText] = useState("");
    const [options, setOptions] = useState([]);
    const [loading, setLoading] = useState(false);
    const [selectedOption, setSelectedOption] = useState(null);

    const handleSearch = async (value) => {
      setSearchText(value);

      if (!value) {
        setOptions([]);
        return;
      }

      setLoading(true);
      try {
        const results = await fetchOptions(value);
        setOptions(results);
      } catch (err) {
        setOptions([]);
      } finally {
        setLoading(false);
      }
    };

    const getDisplayLabel = (opt) => {
      return opt.name || opt.code || "Unknown";
    };

    const handleSelect = (opt) => {
      if (!opt || !opt.id) return;

      setSelectedOption(opt);
      setSearchText(getDisplayLabel(opt));
    };

    const handleSearchClick = () => {
      if (selectedOption) {
        setFilterValue(`filters.${dataIndex}`, {
          value: selectedOption.id,
          label: getDisplayLabel(selectedOption),
        });
      }

      setPage("1");
      tableList(undefined, "1");
      confirm();
    };

    const handleReset = () => {
      setSelectedOption(null);
      setFilterValue(`filters.${dataIndex}`, null);
      setSearchText("");
      setOptions([]);
      clearFilters();
      setPage("1");
      tableList(undefined, "1");
    };

    return (
      <div key={dataIndex} style={{ padding: 8, width: 240 }}>
        <Input
          name={`filters.${dataIndex}`}
          control={control}
          placeholder={`Search ${dataIndex}`}
          value={searchText}
          onChange={(onChange, e) => {
            const value = e.target.value;
            setSearchText(value);
            handleSearch(value);
            onChange(e);
          }}
        />

        <div
          style={{
            maxHeight: 200,
            overflowY: "auto",
            border: "1px solid #f0f0f0",
            borderRadius: 4,
            marginTop: 4,
            background: "#fff",
          }}
        >
          {loading ? (
            <div style={{ textAlign: "center", padding: 10 }}>
              <Spin size="small" />
            </div>
          ) : options?.length > 0 ? (
            options.map((opt) => (
              <div
                key={opt.id}
                onClick={() => handleSelect(opt)}
                style={{
                  padding: "6px 10px",
                  cursor: "pointer",
                  background:
                    selectedOption?.id === opt.id ? "white" : "#e6f7ff",
                }}
              >
                {getDisplayLabel(opt)}
              </div>
            ))
          ) : (
            <div style={{ padding: 10, color: "#999" }}>No results</div>
          )}
        </div>

        <Space style={{ marginTop: 8 }}>
          <Button
            type="primary"
            onClick={handleSearchClick}
            icon={<SearchOutlined />}
            size="small"
            style={{ width: 90 }}
          >
            Search
          </Button>

          <Button onClick={handleReset} size="small" style={{ width: 90 }}>
            Reset
          </Button>
        </Space>
      </div>
    );
  };

  // const handleApplyAll = () => {
  //   if (!applyType) return;

  //   fields.forEach((_, i) => {
  //     const field = applyType;
  //     const valueToApply = selectedValue;

  //     setValue(`items.${i}.${field}`, valueToApply, {
  //       shouldDirty: true,
  //       shouldTouch: true,
  //       shouldValidate: true,
  //     });

  //     fields[i].isModified = true;

  //     clearErrors(`items.${i}.${field}`);
  //   });

  //   const allIds = fields.map((row) => row.itemId);
  //   setSelectedRowKeys(allIds);
  //   setSelectedRows(fields);

  //   setPersistedValues((prev) => ({
  //     ...prev,
  //     [applyType]: selectedValue,
  //   }));

  //   setPopConfirmRow(null);
  //   setApplyType(null);
  // };

  const handleApplyAll = () => {
    if (!applyType) return;

    // Only apply to selected items
    fields.forEach((item, i) => {
      if (selectedRowKeys.includes(item.itemId)) {
        const field = applyType;
        const valueToApply = selectedValue;

        setValue(`items.${i}.${field}`, valueToApply, {
          shouldDirty: true,
          shouldTouch: true,
          shouldValidate: true,
        });

        fields[i].isModified = true;

        clearErrors(`items.${i}.${field}`);
      }
    });

    setPersistedValues((prev) => ({
      ...prev,
      [applyType]: selectedValue,
    }));

    setPopConfirmRow(null);
    setApplyType(null);
  };
  const handleFieldChange = (itemId, field, value, index) => {
    setValue(`items.${index}.${field}`, value, { shouldDirty: true });
  };

  const getHsnRemarkByValue = useCallback(
    (hsnValue) => {
      if (!hsnValue?.value || !hsnCodeOptions?.length) return "";
      const selectedHsn = hsnCodeOptions.find(
        (option) => String(option.id) === String(hsnValue.value),
      );
      return (
        selectedHsn?.remark ||
        selectedHsn?.remarks ||
        selectedHsn?.hsn_remark ||
        ""
      );
    },
    [hsnCodeOptions],
  );

  useEffect(() => {
    if (fields && fields.length) {
      const todayDate = new Date().toISOString().split("T")[0];
      fields.forEach((item, index) => {
        if (!item.startDate) {
          setValue(`items.${index}.startDate`, todayDate, {
            shouldDirty: true,
          });
        }
      });
    }
    // eslint-disable-next-line
  }, [fields, setValue]);

  const columns = [
    {
      title: "Item Code",
      dataIndex: "itemcode",
      key: "itemcode",
      width: 120,
      ...getColumnSearchProps(
        "itemcode",
        async (text) => {
          const results = await getItemcodeList(text, "inv.item.itemlist");
          return results.map((item) => ({
            id: item.id,
            name: item.itemcode,
          }));
        },
        setValue,
        control,
      ),
      render: (text, record) => <span>{record.itemcode}</span>,
    },
    {
      title: "Item Name",
      dataIndex: "itemname",
      key: "itemname",
      width: 180,
      ...getColumnSearchProps(
        "itemname",
        async (text) => {
          const results = await getItemcodeList(text, "inv.item.itemlist");
          return results.map((item) => ({
            id: item.id,
            name: item.name,
          }));
        },
        setValue,
        control,
      ),
      render: (text, record) => <span>{record.itemname}</span>,
    },
    {
      title: "Item Category",
      dataIndex: "category",
      key: "category",
      width: 150,
      ...getColumnSearchProps(
        "category",
        async (text) => {
          const results = await getCatergoryList(text, "inv.item.itemlist");
          return results.map((item) => ({
            id: item.id,
            name: item.name,
          }));
        },
        setValue,
        control,
      ),
      render: (text, record) => <span>{record.category}</span>,
    },
    {
      title: "HSN Code",
      dataIndex: "hsn",
      key: "hsn",
      width: 120,
      render: (text, record) => (
        <Tooltip title={record.hsn_remark}>
          <span className="cursor-pointer hover:underline">{text}</span>
        </Tooltip>
      ),
      ...getColumnSearchProps(
        "hsn",
        async (text) => {
          const results = await getHsnCodeList(text, "inv.item.hsnlist");
          return results.map((item) => ({
            id: item.id,
            name: item.code,
          }));
        },
        setValue,
        control,
      ),
    },
    {
      title: "Current Tax Group",
      dataIndex: "taxgroup",
      key: "taxgroup",
      width: 160,
      ...getColumnSearchProps(
        "taxgroup",
        async (text) => {
          const results = await getTaxGroupList(
            text,
            "acc.account.taxgrouplist",
          );
          return results.map((item) => ({
            id: item.id,
            name: item.name,
          }));
        },
        setValue,
        control,
      ),
    },
    {
      title: "New Category",
      dataIndex: "newcategory",
      key: "newcategory",
      width: 200,
      ...getColumnSearchProps(
        "category",
        async (text) => {
          const results = await getCatergoryList(
            text,
            "inv.item.itemcontentlist",
          );
          return results.map((item) => ({
            id: item.id,
            name: item.name,
          }));
        },
        setValue,
        control,
      ),
      render: (_, record, index) => {
        const selectComponent = (
          <div className="mt-7">
            <Select
              name={`items.${index}.newcategory`}
              placeholder="Search Category"
              control={control}
              options={catergory?.map((oOption) => ({
                value: oOption.id,
                label: oOption.name,
              }))}
              showSearch
              allowClear
              onSearch={(e) => {
                getCatergoryList(e, "inv.item.itemcontentlist");
              }}
              onChange={(value, onChange) => {
                onChange(value);
                fields[index].isModified = true;
                handleFieldChange(record.itemId, "newcategory", value, index);
                autoSelectRow(record);
                setSelectedValue(value);
                setApplyType("newcategory");
                setPopConfirmRow(index);
              }}
              className="h-10"
            />
          </div>
        );
        if (fields.length > 1) {
          return (
            <Popconfirm
              title={
                <div
                  style={{ color: "red" }}
                >{`Do You Want to Apply this New Category to selected ${selectedRowKeys.length} items?`}</div>
              }
              onConfirm={handleApplyAll}
              onCancel={() => setPopConfirmRow(null)}
              okText="Yes"
              cancelText="No"
              open={popConfirmRow === index && applyType === "newcategory"}
            >
              {selectComponent}
            </Popconfirm>
          );
        }
        return selectComponent;
      },
    },
    {
      title: "New Tax Group",
      key: "newTaxGroup",
      width: 200,
      render: (_, record, index) => {
        const selectComponent = (
          <div className="mt-7">
            <Select
              name={`items.${index}.taxGroup`}
              control={control}
              placeholder="Search Tax Group"
              options={taxGroupOptions?.map((o) => ({
                value: o.id,
                label: o.name,
              }))}
              showSearch
              allowClear
              onSearch={(e) => getTaxGroupList(e, "acc.account.taxgrouplist")}
              onChange={(value, onChange) => {
                onChange(value);
                fields[index].isModified = true;
                handleFieldChange(record.itemId, "taxGroup", value, index);
                autoSelectRow(record);
                setSelectedValue(value);
                setApplyType("taxGroup");
                setPopConfirmRow(index);
              }}
            />
          </div>
        );
        if (fields.length > 1) {
          return (
            <Popconfirm
              title={
                <div
                  style={{ color: "red" }}
                >{`Do You Want to Apply this Tax Group to selected ${selectedRowKeys.length} items?`}</div>
              }
              onConfirm={handleApplyAll}
              onCancel={() => setPopConfirmRow(null)}
              okText="Yes"
              cancelText="No"
              open={popConfirmRow === index && applyType === "taxGroup"}
            >
              {selectComponent}
            </Popconfirm>
          );
        }
        return selectComponent;
      },
    },
    {
      title: "New HSN Code",
      key: "newHsnCode",
      width: 200,
      render: (_, record, index) => {
        const selectedHsnValue = getValues(`items.${index}.hsnCode`);
        const selectedHsnRemark =
          selectedHsnValue?.remark || getHsnRemarkByValue(selectedHsnValue);

        const selectComponent = (
          <div className="mt-7">
            <Select
              name={`items.${index}.hsnCode`}
              control={control}
              placeholder="Search HSN Code"
              options={hsnCodeOptions?.map((o) => ({
                value: o.id,
                label: o.code,
              }))}
              showSearch
              allowClear
              onSearch={(e) => getHsnCodeList(e, "inv.item.hsnlist")}
              onChange={(value, onChange) => {
                const option = hsnCodeOptions?.find(
                  (o) => String(o.id) === String(value?.value),
                );
                const remark = option?.remark 
                const enrichedValue = value ? { ...value, remark } : value;

                onChange(enrichedValue);
                fields[index].isModified = true;
                handleFieldChange(
                  record.itemId,
                  "hsnCode",
                  enrichedValue,
                  index,
                );
                autoSelectRow(record);
                setSelectedValue(enrichedValue);
                setApplyType("hsnCode");
                setPopConfirmRow(index);
              }}
            />
          </div>
        );

        if (fields.length > 1) {
          return (
            <Popconfirm
              title={
                <div style={{ maxWidth: 350, wordBreak: "break-word" }}>
                  <div style={{ marginTop: 10, color: "#0000000" }}>
                    {selectedHsnRemark || "No remark available for selected HSN Code"}
                  </div>
                  <div
                    style={{ color: "red" }}
                  >{`Do You Want to Apply this HSN Code to selected ${selectedRowKeys.length} items?`}</div>
                </div>
              }
              onConfirm={handleApplyAll}
              onCancel={() => setPopConfirmRow(null)}
              okText="Yes"
              cancelText="No"
              open={popConfirmRow === index && applyType === "hsnCode"}
            >
              {selectComponent}
            </Popconfirm>
          );
        }
        return selectComponent;
      },
    },
    {
      title: "Start Date",
      key: "startDate",
      width: 130,
      render: (_, record, index) => {
        const today = new Date().toISOString().split("T")[0];

        return (
          <Controller
            name={`items.${index}.startDate`}
            control={control}
            defaultValue={today}
            render={({ field, fieldState }) => (
              <>
                <Popconfirm
                  title={
                    <div
                      style={{ color: "red" }}
                    >{`Do You Want to Apply this Start Date to selected ${selectedRowKeys.length} items?`}</div>
                  }
                  onConfirm={handleApplyAll}
                  onCancel={() => setPopConfirmRow(null)}
                  okText="Yes"
                  cancelText="No"
                  open={popConfirmRow === index && applyType === "startDate"}
                >
                  <input
                    type="date"
                    className={`w-full p-1 border rounded ${
                      fieldState.error ? "border-red-500" : "border-gray-300"
                    }`}
                    value={field.value || today}
                    min={today}
                    onChange={(e) => {
                      const date = e.target.value;
                      field.onChange(date);
                      fields[index].isModified = true;
                      handleFieldChange(
                        record.itemId,
                        "startDate",
                        date,
                        index,
                      );
                      autoSelectRow(record);
                      setSelectedValue(date);
                      setApplyType("startDate");
                      setPopConfirmRow(index);
                    }}
                  />
                </Popconfirm>
                {fieldState.error && (
                  <p className="mt-1 text-xs text-red-500">
                    {fieldState.error.message}
                  </p>
                )}
              </>
            )}
          />
        );
      },
    },
    {
      title: "Last Updated Date",
      key: "updated_dot",
      dataIndex: "updated_dot",
      width: 140,
    },
  ];
  // useEffect(() => {
  //   tableList(undefined, "1");
  // }, [showStock, activeItems]);

  return (
    <div className="h-screen px-12 pt-6 pb-12 bg-gray-50 ">
      <Header />
      <div className="p-10 bg-white shadow-lg rounded-2xl">
        <div className="flex flex-wrap justify-between">
          <h1 className="mb-6 text-2xl font-bold text-gray-800">
            Tax Group Management
          </h1>
          {messageContextHolder}
          <div className="flex items-center justify-end gap-2">
            <div className="pt-4">
              <Checkbox
                label="Active"
                control={control}
                showUpperLabel={false}
                name="active"
                defaultValue={true}
                // onChange={(value, onChange) => {
                //   onChange(value);
                //   tableList(undefined, "1");
                // }}
              />
            </div>
            <div className="pt-4">
              <Checkbox
                label="Show Stock"
                control={control}
                showUpperLabel={false}
                name="stock"
                defaultValue={true}
                // onChange={(value, onChange) => {
                //   onChange(value);
                //   tableList(undefined, "1");
                // }}
              />
            </div>
            <button
              className="inline-flex items-center justify-end h-10 px-4 py-2 text-sm font-medium text-white transition-colors bg-blue-600 rounded-md focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 hover:bg-blue-700"
              onClick={handleSubmit(onSubmit)}
            >
              {canApprove
                ? "Approve"
                : canDraft
                  ? "Save Draft Changes"
                  : "Save changes"}
            </button>
          </div>
        </div>
        <div className="grid grid-cols-1 gap-4 rounded-md md:grid-cols-5 bg-[#F6F7F8] pt-3 px-3 ">
          <Select
            name="department"
            label="Department"
            placeholder="Search Across all columns"
            control={control}
            options={departmentList?.map((oOption) => ({
              value: oOption.id,
              label: oOption.name,
            }))}
            showArrow={true}
            showSearch
            allowClear
            mode="multiple"
            className="h-10"
            dropdownStyle={{ maxHeight: 300, overflowY: "auto", minWidth: 250 }}
            maxTagCount="responsive"
            onSearch={(e) => {
              getdepartmentlist(e, "inv.item.departmentlist");
            }}
          />
          <Select
            name="manufacturer"
            label="Manufacturer"
            placeholder="Search Across all columns"
            control={control}
            options={manufacturerOptions?.map((oOption) => ({
              value: oOption.id,
              label: oOption.name,
            }))}
            showArrow={true}
            showSearch
            allowClear
            onSearch={(e) => {
              getManufacturerList(e, "acc.party.partylist", true, false);
            }}
            className="h-10"
            dropdownStyle={{ maxHeight: 300, overflowY: "auto", minWidth: 250 }}
            maxTagCount="responsive"
          />
          <Select
            name="distributor"
            label="Supplier / Distributor"
            placeholder="Search Across all columns"
            control={control}
            options={distributorOptions?.map((oOption) => ({
              value: oOption.id,
              label: oOption.name,
            }))}
            showArrow={true}
            showSearch
            allowClear
            onSearch={(e) => {
              getManufacturerList(e, "acc.party.partylist", false, true);
            }}
            className="h-10"
            dropdownStyle={{ maxHeight: 300, overflowY: "auto", minWidth: 250 }}
            maxTagCount="responsive"
          />
          <Select
            name="category"
            label="Item Category"
            placeholder="Search Across all columns"
            control={control}
            options={catergory?.map((oOption) => ({
              value: oOption.id,
              label: oOption.name,
            }))}
            showSearch
            allowClear
            onSearch={(e) => {
              getCatergoryList(e, "inv.item.itemcontentlist");
            }}
            className="h-10"
            dropdownStyle={{ maxHeight: 300, overflowY: "auto", minWidth: 250 }}
            maxTagCount="responsive"
          />
          <Select
            name="itemname"
            label="Item Name"
            placeholder="Search Across all columns"
            control={control}
            options={itemNameList?.map((oOption) => ({
              value: oOption.id,
              label: oOption.name,
            }))}
            showSearch
            allowClear
            onSearch={(e) => {
              getItemcodeList(e, "inv.item.itemlist");
            }}
            className="h-10"
            dropdownStyle={{ maxHeight: 300, overflowY: "auto", minWidth: 250 }}
            maxTagCount="responsive"
          />
        </div>

        {loading ? (
          <div className="flex items-center justify-center h-96">
            <Spin size="large" tip="Loading..." />
          </div>
        ) : (
          <Table
            className="custom-table"
            columns={columns}
            dataSource={fields}
            loading={loading}
            rowSelection={rowSelection}
            scroll={{ y: 500 }}
            rowKey={(record) => record.itemId || record.id || record.itemid}
            pagination={{
              current: Number(page),
              pageSize: pageSize,
              total: totalCount,
              showSizeChanger: false,
              onChange: (pageNumber) => setPage(String(pageNumber)),
            }}
          />
        )}
      </div>
    </div>
  );
};
export default TaxGroup;
